import React, { SelectHTMLAttributes } from 'react';
import './Select.style.scss';

export interface IOption {
  text: string;
  value: string | number;
}

export interface IProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: IOption[];
}

const Select = (props: IProps) => {
  return (
    <select
      {...{ ...props, options: undefined }}
      className={`select ${props.className || ''}`}
    >
      {props.options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  );
};

export default React.memo(Select);
